
<div class="page-customized">
    <v-progress-linear
        v-if="overlay"
        absolute
        indeterminate
    ></v-progress-linear>

    <app-bar
        :title="content.exists() ? t('club_content_title_update') : t('club_content_title_create')"
        back="/club-contents"
    />

    <v-layout class="mt-n8">
        <v-card
            width="100%"
            color="transparent"
            elevation="0"
            class="pb-8"
        >
            <v-card-text class="pb-0">
                <v-form class="mt-6">
                    <div class="form-group-horizontal">
                        <div class="horizontal-label">{{ t('club_content_label_type') }}</div>
                        <div class="horizontal-input">
                            <v-select
                                v-model="content.type"
                                :items="clubContentTypes()"
                                required
                                outlined
                                append-icon="mdi-chevron-down"
                                dense
                                :error-messages="form.errors.get('type')"
                            ></v-select>
                        </div>
                    </div>
                    <div class="form-group-horizontal">
                        <div class="horizontal-label">{{ t('club_content_label_name') }}</div>
                        <div class="horizontal-input">
                            <v-text-field
                                v-model="content.name"
                                type="text"
                                required
                                outlined
                                dense
                                :error-messages="form.errors.get('name')"
                            ></v-text-field>
                        </div>
                        <div class="horizontal-actions">
                            <edit-translations-modal
                                v-model="content.name"
                                :items="content.translations['name']"
                                @touch="(v) => content.translations['name'] = v"
                            ></edit-translations-modal>
                        </div>
                    </div>
                    <div class="form-group-horizontal">
                        <div class="horizontal-label">{{ t('club_content_label_description') }}</div>
                        <div class="horizontal-input">
                            <v-textarea
                                v-model="content.description"
                                outlined
                                dense
                                :error-messages="form.errors.get('description')"
                            ></v-textarea>
                        </div>
                        <div class="horizontal-actions">
                            <edit-translations-modal
                                v-model="content.description"
                                :items="content.translations['description']"
                                @touch="(v) => content.translations['description'] = v"
                                text
                            ></edit-translations-modal>
                        </div>
                    </div>
                    <div class="form-group-horizontal" v-if="content.isVideo()">
                        <div class="horizontal-label">{{ t('club_content_label_video_url') }}</div>
                        <div class="horizontal-input">
                            <v-text-field
                                v-model="content.videoUrl"
                                type="text"
                                outlined
                                dense
                                :error-messages="form.errors.get('video_url')"
                            ></v-text-field>
                        </div>
                    </div>
                    <div class="form-group-horizontal">
                        <div class="horizontal-label">{{ t('club_content_label_icon') }}</div>
                        <div class="horizontal-input">
                            <v-file-input
                                v-model="content.photo"
                                outlined
                                prepend-icon=""
                                prepend-inner-icon="mdi-paperclip"
                                :append-outer-icon="content.photoUrl ? 'mdi-eye-outline' : ''"
                                dense
                                :error-messages="photoForm.errors.get('photo')"
                                @click:append-outer="viewPhoto(content.photoUrl)"
                                @click:clear="content.photo = undefined"
                            ></v-file-input>
                        </div>
                    </div>
                    <div class="form-group-horizontal" v-if="content.photos && content.photos.length">
                        <v-sheet
                            v-for="(photo, i) in content.photos"
                            :key="photo"
                            color="white"
                            elevation="0"
                            height="200"
                            width="200"
                            class="float-left mr-8 mb-8 bordered position-relative"
                        >
                            <v-img
                                :lazy-src="photo"
                                :src="photo"
                                max-height="150"
                                max-width="150"
                                class="mx-auto mt-6"
                            ></v-img>
                            <confirm-modal
                                :title="t('general_title_confirm_action')"
                                @agree="content.delPhoto(i)"
                            >
                                <template #default="{ on, attrs }">
                                    <v-btn
                                        v-on="on"
                                        v-bind="attrs"
                                        plain
                                        icon
                                        absolute
                                        top
                                        right
                                        class="mt-n5 mr-n5"
                                    ><v-icon color="orange">mdi-close</v-icon></v-btn>
                                </template>
                            </confirm-modal>
                            <v-btn
                                v-if="i !== 0"
                                @click="content.updatePhotoNumber(i, (i - 1))"
                                plain
                                icon
                                absolute
                                bottom
                                left
                                class="mb-n5 ml-n5"
                            ><v-icon color="customized-primary">mdi-arrow-left</v-icon></v-btn>
                            <v-btn
                                v-if="i !== content.photos.length - 1"
                                @click="content.updatePhotoNumber(i, (i + 1))"
                                plain
                                icon
                                absolute
                                bottom
                                right
                                class="mb-n5 mr-n5"
                            ><v-icon color="customized-primary">mdi-arrow-right</v-icon></v-btn>
                        </v-sheet>
                    </div>
                    <div class="form-group-horizontal">
                        <div class="horizontal-label">{{ t('club_content_label_header_photos') }}</div>
                        <div class="horizontal-input">
                            <v-file-input
                                v-model="content.photoUps"
                                outlined
                                prepend-icon=""
                                prepend-inner-icon="mdi-paperclip"
                                dense
                                multiple
                                :error-messages="photoForm.errors.get('photos.0') || photoForm.errors.get('photos')"
                                @click:clear="content.photoUps = undefined"
                            ></v-file-input>
                        </div>
                    </div>
                    <div class="form-group-horizontal">
                        <div class="horizontal-label">{{ t('general_action_published') }}</div>
                        <div class="horizontal-input">
                            <v-switch
                                class="ma-0"
                                v-model="content.enabled"
                            ></v-switch>
                        </div>
                    </div>
                </v-form>
            </v-card-text>

            <v-card-actions class="px-4">
                <v-btn
                    :to="{ name: 'club-contents' }"
                    class="mr-4"
                    color="primary"
                >{{ t('general_action_cancel') }}</v-btn>
                <v-btn
                    :loading="form.busy"
                    :disabled="form.busy"
                    color="orange"
                    @click.prevent="submit"
                >{{ content.exists() ? t('general_action_save') : t('club_content_title_create') }}</v-btn>
            </v-card-actions>
        </v-card>
    </v-layout>
</div>
